import React, { useState, useEffect } from "react";
import { auth, functions } from "../firebase";
import { httpsCallable } from "firebase/functions";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getFirestore, collection, addDoc, serverTimestamp, query, where, orderBy, onSnapshot } from "firebase/firestore";

export default function Deposit({ user, onBack }) {
  const [tab, setTab] = useState("card");
  const [amount, setAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [file, setFile] = useState(null);
  const [bankName, setBankName] = useState("");
  const [uploading, setUploading] = useState(false);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    const db = getFirestore();
    const q = query(
      collection(db, "deposits"),
      where("userId", "==", user.uid),
      orderBy("createdAt", "desc")
    );
    const unsub = onSnapshot(q, snap => {
      setHistory(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    });
    return unsub;
  }, [user]);

  const handleCardDeposit = async () => {
    if (!amount || Number(amount) < 10) { setMsg("Minimum deposit is $10"); return; }
    setLoading(true); setMsg("");
    try {
      const createSession = httpsCallable(functions, "createCheckoutSession");
      const result = await createSession({ amount: Number(amount) });
      window.location.href = result.data.url;
    } catch (e) {
      setMsg("Error: " + e.message);
      setLoading(false);
    }
  };

  const handleBankSubmit = async () => {
    if (!amount || Number(amount) < 1) { setMsg("Masukkan jumlah transfer"); return; }
    if (!file) { setMsg("Upload bukti transfer dulu"); return; }
    setUploading(true); setMsg("");
    try {
      const storage = getStorage();
      const storageRef = ref(storage, `proofs/${user.uid}_${Date.now()}`);
      await uploadBytes(storageRef, file);
      const url = await getDownloadURL(storageRef);
      const db = getFirestore();
      await addDoc(collection(db, "deposits"), {
        userId: user.uid,
        email: user.email,
        amount: Number(amount),
        method: "bank",
        bankName,
        proofUrl: url,
        status: "pending",
        createdAt: serverTimestamp(),
      });
      setMsg("✓ Bukti transfer berhasil dikirim! Admin akan konfirmasi dalam 1x24 jam.");
      setAmount(""); setFile(null); setBankName("");
    } catch (e) {
      setMsg("Error: " + e.message);
    }
    setUploading(false);
  };

  const handleCryptoSubmit = async () => {
    if (!amount || Number(amount) < 1) { setMsg("Masukkan jumlah transfer"); return; }
    setUploading(true); setMsg("");
    try {
      const db = getFirestore();
      await addDoc(collection(db, "deposits"), {
        userId: user.uid,
        email: user.email,
        amount: Number(amount),
        method: "crypto",
        status: "pending",
        createdAt: serverTimestamp(),
      });
      setMsg("✓ Deposit crypto tercatat! Admin akan konfirmasi setelah menerima transfer.");
      setAmount("");
    } catch (e) {
      setMsg("Error: " + e.message);
    }
    setUploading(false);
  };

  return (
    <div className="deposit-page">
      <div className="dep-header">
        <button className="btn-back" onClick={onBack}>← Back</button>
        <div className="dep-page-title">Deposit Funds</div>
      </div>

      <div className="dep-tabs">
        <div className={`dep-tab ${tab === "card" ? "active" : ""}`} onClick={() => { setTab("card"); setMsg(""); }}>
          <span className="dep-tab-icon">💳</span> Visa / Mastercard
        </div>
        <div className={`dep-tab ${tab === "bank" ? "active" : ""}`} onClick={() => { setTab("bank"); setMsg(""); }}>
          <span className="dep-tab-icon">🏦</span> Bank Transfer
        </div>
        <div className={`dep-tab ${tab === "crypto" ? "active" : ""}`} onClick={() => { setTab("crypto"); setMsg(""); }}>
          <span className="dep-tab-icon">⟠</span> Crypto ETH
        </div>
        <div className={`dep-tab ${tab === "history" ? "active" : ""}`} onClick={() => { setTab("history"); setMsg(""); }}>
          <span className="dep-tab-icon">📋</span> History
        </div>
      </div>

      <div className="dep-content">

        {tab === "card" && (
          <div className="dep-panel">
            <div className="dep-panel-title">Pay with Visa / Mastercard</div>
            <div className="dep-panel-sub">Secure payment powered by Stripe. Supports Visa, Mastercard, Amex.</div>
            <label className="dep-label">Amount (USD)</label>
            <input className="inp" type="number" placeholder="Minimum $10" value={amount} onChange={e => setAmount(e.target.value)} />
            {msg && <div className="dep-msg">{msg}</div>}
            <button className="btn-main btn-full" onClick={handleCardDeposit} disabled={loading}>
              {loading ? "Redirecting..." : "Continue to Payment →"}
            </button>
            <div className="dep-secure">🔒 Secured by Stripe — we never store your card details</div>
          </div>
        )}

        {tab === "bank" && (
          <div className="dep-panel">
            <div className="dep-panel-title">Bank Transfer</div>
            <div className="dep-bank-info">
              <div className="dep-bank-row"><span>Bank</span><span>BNI</span></div>
              <div className="dep-bank-row"><span>Account Number</span><span className="dep-acc">1321767727</span></div>
              <div className="dep-bank-row"><span>Account Name</span><span>PT Artemis Bosphora Arthagena</span></div>
            </div>
            <label className="dep-label">Amount Transferred (USD)</label>
            <input className="inp" type="number" placeholder="Enter amount" value={amount} onChange={e => setAmount(e.target.value)} />
            <label className="dep-label">Your Bank Name</label>
            <input className="inp" type="text" placeholder="e.g. BCA, Mandiri, BNI" value={bankName} onChange={e => setBankName(e.target.value)} />
            <label className="dep-label">Upload Proof of Transfer</label>
            <div className="dep-upload" onClick={() => document.getElementById("proof-upload").click()}>
              {file ? <span style={{color: "#00C896"}}>✓ {file.name}</span> : <span>Click to upload screenshot / receipt</span>}
              <input id="proof-upload" type="file" accept="image/*,.pdf" style={{display:"none"}} onChange={e => setFile(e.target.files[0])} />
            </div>
            {msg && <div className="dep-msg">{msg}</div>}
            <button className="btn-main btn-full" onClick={handleBankSubmit} disabled={uploading}>
              {uploading ? "Submitting..." : "Submit Transfer Proof"}
            </button>
          </div>
        )}

        {tab === "crypto" && (
          <div className="dep-panel">
            <div className="dep-panel-title">Crypto — ETH</div>
            <div className="dep-panel-sub">Send ETH to the address below, then confirm your deposit.</div>
            <div className="dep-crypto-box">
              <div className="dep-crypto-label">ETH Wallet Address</div>
              <div className="dep-crypto-addr">0x1a426B08980D92bEaD8EA6231556693DF3D661C0</div>
              <button className="btn-copy" onClick={() => { navigator.clipboard.writeText("0x1a426B08980D92bEaD8EA6231556693DF3D661C0"); setMsg("Address copied!"); }}>Copy</button>
            </div>
            <label className="dep-label">Amount Sent (USD equivalent)</label>
            <input className="inp" type="number" placeholder="Enter USD value" value={amount} onChange={e => setAmount(e.target.value)} />
            {msg && <div className="dep-msg">{msg}</div>}
            <button className="btn-main btn-full" onClick={handleCryptoSubmit} disabled={uploading}>
              {uploading ? "Submitting..." : "I Have Sent the ETH"}
            </button>
            <div className="dep-secure">Admin will verify your transaction on the blockchain.</div>
          </div>
        )}

        {tab === "history" && (
          <div>
            <div className="dep-panel-title" style={{marginBottom:"16px"}}>Deposit History</div>
            {history.length === 0 ? (
              <div style={{textAlign:"center", color:"#5A6480", padding:"60px"}}>No deposit history yet</div>
            ) : (
              <table style={{width:"100%", borderCollapse:"collapse", fontSize:"13px"}}>
                <thead>
                  <tr>
                    {["Amount","Method","Bank/Note","Status","Date"].map(h => (
                      <th key={h} style={{textAlign:"left", padding:"8px 12px", fontSize:"10px", letterSpacing:"1px", textTransform:"uppercase", color:"#5A6480", borderBottom:"1px solid #1E2840"}}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {history.map(d => (
                    <tr key={d.id}>
                      <td style={{padding:"10px 12px", borderBottom:"1px solid #1E2840", fontFamily:"monospace", fontWeight:"700", color:"#00C896"}}>
                        +${d.amount?.toFixed(2)}
                      </td>
                      <td style={{padding:"10px 12px", borderBottom:"1px solid #1E2840"}}>
                        {d.method === "stripe" ? "💳 Card" : d.method === "crypto" ? "⟠ ETH" : "🏦 Bank"}
                      </td>
                      <td style={{padding:"10px 12px", borderBottom:"1px solid #1E2840", color:"#5A6480", fontSize:"11px"}}>
                        {d.bankName || (d.proofUrl ? <a href={d.proofUrl} target="_blank" rel="noreferrer" style={{color:"#F0A500"}}>View Proof</a> : "-")}
                      </td>
                      <td style={{padding:"10px 12px", borderBottom:"1px solid #1E2840"}}>
                        <span style={{
                          padding:"3px 8px", borderRadius:"4px", fontSize:"10px", fontWeight:"700",
                          background: d.status === "pending" ? "rgba(240,165,0,0.12)" : d.status === "approved" ? "rgba(0,200,150,0.12)" : "rgba(255,59,92,0.12)",
                          color: d.status === "pending" ? "#F0A500" : d.status === "approved" ? "#00C896" : "#FF3B5C"
                        }}>{d.status}</span>
                      </td>
                      <td style={{padding:"10px 12px", borderBottom:"1px solid #1E2840", color:"#5A6480", fontSize:"11px"}}>
                        {d.createdAt?.toDate ? d.createdAt.toDate().toLocaleDateString() : "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}

      </div>
    </div>
  );
}